import React, { useMemo, useState } from "react";
import NumberedPagination from "../../pagination/NumberedPagination";
import ExamItem from "./ExamItem";

const ExamList = ({ exams }) => {
  const pageSize = 5;

  const [currentPage, setCurrentPage] = useState(1);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return exams?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, exams]);

  const len = exams?.length;

  return (
    <div className="flex flex-col gap-4">
      <div className="sm:w-full w-[calc(100vw-120px)] overflow-x-auto">
        <table className="w-full text-center">
          <thead className="text-sm uppercase ">
            <tr className="text-textSecondary tracking-wider border-b p-2 ">
              <th className="p-2 overflow-clip">ID</th>
              <th className="p-2 overflow-clip">Topic</th>
              <th className="p-2 overflow-clip">From</th>
              <th className="p-2 overflow-clip">To</th>
              <th className="p-2 overflow-clip">Action</th>
            </tr>
          </thead>
          <tbody>
            {exams?.length === 0 ? (
              <tr className="border-b">
                <td colSpan="5" className="text-center px-2 py-4">
                  No exam found
                </td>
              </tr>
            ) : (
              currentTableData.map((entry, index) => (
                <ExamItem
                  data={entry}
                  index={index + (currentPage - 1) * pageSize}
                  key={index}
                />
              ))
            )}
          </tbody>
        </table>
      </div>
      <NumberedPagination
        currentPage={currentPage}
        totalCount={len}
        pageSize={pageSize}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
};

export default ExamList;
